import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { TslApiModule } from 'projects/aztalena-core/src/public-api';
import { environment } from 'src/environments/environment';
import { AnnouncementService } from './announcement/announcement.service';
import { AnnouncementComponent } from './announcement/announcement/announcement.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './auth.service';
import { RefreshTokenInterceptor } from './auth/auth.interceptor';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { SignUpTOSComponent } from './auth/sign-up/sign-up-tos/sign-up-tos.component';
import { SignUpUserComponent } from './auth/sign-up/sign-up-user/sign-up-user.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { AvatarService } from './avatar/avatar.service';
import { CoreModule } from './core/core.module';
import { ForumTopicTitleComponent } from './forum/forum-topic-title/forum-topic-title.component';
import { ForumService } from './forum/forum.service';
import { GiftComponent } from './gift/gift.component';
import { GiftService } from './gift/gift.service';
import { SendGiftDialogComponent } from './gift/send-gift-dialog/send-gift-dialog.component';
import { HomeForumItemComponent } from './home/home-forum-item/home-forum-item.component';
import { HomeForumComponent } from './home/home-forum/home-forum.component';
import { HomeHeaderComponent } from './home/home-header/home-header.component';
import { HomeUserComponent } from './home/home-user/home-user.component';
import { HomeComponent } from './home/home.component';
import { ReportDialogComponent } from './report/report-dialog/report-dialog.component';
import { ReportService } from './report/report.service';
import { SharedModule } from './shared/shared.module';
import { ThemeModule } from './theme/theme.module';
import { TopicPostResolver } from './topic.resolver';
import { TopicService } from './topic.service';
import { AvatarPartComponent } from './user/select-avatar/avatar-part/avatar-part.component';
import { BuyingPartsDialogComponent } from './user/select-avatar/buying-parts-dialog/buying-parts-dialog.component';
import { SelectAvatarImagePreviewComponent } from './user/select-avatar/select-avatar-image-preview/select-avatar-image-preview.component';
import { SelectAvatarItemSelectComponent } from './user/select-avatar/select-avatar-item-select/select-avatar-item-select.component';
import { SelectAvatarComponent } from './user/select-avatar/select-avatar.component';
import { TribeService } from './user/tribe.service';
import { UserGiftsComponent } from './user/user-gifts/user-gifts.component';
import { ChangePasswordComponent } from './user/user-setting/change-password/change-password.component';
import { EditProfileComponent } from './user/user-setting/edit-profile/edit-profile.component';
import { UserSettingsComponent } from './user/user-setting/user-settings.component';
import { UserSetupComponent } from './user/user-setup/user-setup.component';
import { UserTopicsComponent } from './user/user-topics/user-topics.component';
import { UserInfoResolver } from './user/user.resolver';
import { UserComponent } from './user/user/user.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

@NgModule({
  declarations: [
    AnnouncementComponent,
    AppComponent,
    ChangePasswordComponent,
    EditProfileComponent,
    ForgetPasswordComponent,
    ForumTopicTitleComponent,
    GiftComponent,
    HomeComponent,
    HomeForumComponent,
    HomeForumItemComponent,
    HomeHeaderComponent,
    ReportDialogComponent,
    ResetPasswordComponent,
    SignInComponent,
    SignUpUserComponent,
    SignUpComponent,
    SignUpTOSComponent,
    UserComponent,
    UserGiftsComponent,
    UserSettingsComponent,
    UserSetupComponent,
    UserTopicsComponent,
    SelectAvatarComponent,
    SelectAvatarImagePreviewComponent,
    SelectAvatarItemSelectComponent,
    VerifyEmailComponent,
    SendGiftDialogComponent,
    HomeUserComponent,
    AvatarPartComponent,
    BuyingPartsDialogComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CoreModule,
    FormsModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    ReactiveFormsModule,
    SharedModule,
    ThemeModule,
    TslApiModule.forRoot({ apiHost: environment.apiHost })
  ],
  providers: [
    AnnouncementService,
    AuthService,
    AvatarService,
    ForumService,
    GiftService,
    ReportService,
    TopicPostResolver,
    TopicService,
    TribeService,
    UserInfoResolver,
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
